import {Button, Card, Stack, Typography} from "@mui/material";
import React, {useCallback, useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {addExpenditure, addItinerary, addTrip, auth, generateStartEndDateTexts, setAllPlacesAsFulfilled, TripModel} from "../firebase/index.js";
import {setTrip} from "../redux/InMemoryTripReducer.js";
import type {APXBaseOption, APXOptions} from "../reusables/APXMoreMenuWithPopover.jsx";
import APXMoreMenuWithPopover from "../reusables/APXMoreMenuWithPopover.jsx";
import {webappPaths} from "../reusables/js/AppRoutes.js";
import {red_900} from "../reusables/js/APXTheme.js";
import AddNewTripBSL from "./AddNewTripBSL.jsx";


export default function TripLayout({item}: { item: TripModel }) {
	  const trip: TripModel = item;
	  const history = useHistory();
	  
	  const dispatch = useDispatch();
	  
	  const setTripToStore = () => {
			 dispatch(setTrip(trip));
	  };
	  
	  const handleExpenditureButtonClick = () => {
			 setTripToStore();
			 history.replace(webappPaths.expenditure);
	  };
	  
	  const handleItineraryButtonClick = () => {
			 setTripToStore();
			 history.replace(webappPaths.itinerary);
	  };
	  
	  //  const {currentItem, currentOption, setCurrentItem, setCurrentOption, showBottomSheet, setShowBottomSheet} = useCurrentSelectedOption({});
	  const [showBottomSheet, setShowBottomSheet] = useState(false);
	  
	  const uid = useAuthState(auth)[0]?.uid;
	  
	  const tripMenuOptions: APXOptions = {
			 complete: {
					label: "Mark as completed",
					needsConfirmation: true,
					keepDisabled: trip.isCompleted,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  trip.setAsCompleted();
						  addTrip(uid, trip.tripKey, trip);
						  setAllPlacesAsFulfilled(uid, trip.itineraryKey);
					}, [uid])
			 },
			 archive: {
					label: "Archive",
					needsConfirmation: true,
					keepDisabled: trip.isCompleted || trip.isArchived,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  trip.setAsArchived();  // ALSO SETS AS COMPLETED
						  addTrip(uid, trip.tripKey, trip);
						  setAllPlacesAsFulfilled(uid, trip.itineraryKey);
					}, [uid])
			 },
			 share: {
					label: "Share",
					needsConfirmation: false,
					keepDisabled: true,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  console.log("Share"); // TODO
					}, [uid])
			 },
			 edit: {
					label: "Edit",
					needsConfirmation: false,
					keepDisabled: trip.isCompleted || /*NOT->*/ !trip.isEditable,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  setShowBottomSheet(true);
					}, [uid])
			 },
			 delete: {
					label: "Delete",
					needsConfirmation: true,
					keepDisabled: false,
					onClick: useCallback(() => {
						  if (/*FALSY->*/ !!!uid) return;
						  addTrip(uid, trip.tripKey, null);
						  addItinerary(uid, trip.itineraryKey, null);
						  addExpenditure(uid, trip.expenditureKey, null);
					}, [uid])
			 }
	  };
	  
	  
	  return (
				 <Card variant={"outlined"} sx={{p: 2, mt: 1, borderColor: red_900, opacity: trip.isCompleted ? 0.75 : 1}}>
						<Stack direction="row" justifyContent="space-between" alignItems="center">
							  <Typography variant="h4" sx={{flex: 1}}>{trip.tripTo}</Typography>
							  <APXMoreMenuWithPopover options={tripMenuOptions}
															  onConfirmedOptionSelected={(option: APXBaseOption) => {
																	 option && option.onClick();
															  }}/>
							  {
										 showBottomSheet &&
										 <AddNewTripBSL uid={uid} onClose={() => setShowBottomSheet(false)} trip={trip}/>
							  }
						</Stack>
						<Typography variant="h6">{generateStartEndDateTexts(trip)}</Typography>
						<Typography variant="body1" sx={{visibility: trip.tripNote ? "visible" : "hidden"}}>{trip.tripNote}</Typography>
						<Stack direction="row" mt={1} spacing={2} justifyContent="center">
							  <Button variant={"contained"} fullWidth onClick={handleExpenditureButtonClick}>Shared Expenses</Button>
							  <Button variant={"contained"} fullWidth onClick={handleItineraryButtonClick}>Trip Itinerary</Button>
						</Stack>
				 </Card>
	  );
}